export const ROOT_URL = '/CorrLogix/';

export const SUPPORT_EMAIL = 'aip@corrprocanada.com';
